import React from 'react';

import { useCurrentUser } from '@docavenue/components';
import { isEmpty } from 'lodash';
import {
  getFavoritePractionerIds,
  getReferringPractitionerIds,
} from '../../../src/utils';
import { useTranslation } from '@/src/i18n';
import FontAwesomeIcon from '@/components/atoms/FontawesomeIcon/FontawesomeIcon';

type Props = {
  practitionerId?: string;
  profileId?: string;
};
// if your flag practitioner concerne a current patient, then provide in props to FlagPractitioner then object current patient
const PractitionerFlag = ({ practitionerId, profileId }: Props) => {
  const { t } = useTranslation();
  const user = useCurrentUser();
  if (isEmpty(user)) return null;
  const profiles = user?.userPatientInformation?.userPatientProfiles ?? [];
  const profile =
    typeof profileId === 'undefined'
      ? null
      : profiles.find(({ id }) => id === profileId);
  if (profileId && !profile) {
    return null;
  }
  const referringPractitioner = profile?.referringPractitioner?.practitionerId
    ? [profile?.referringPractitioner?.practitionerId]
    : [];
  const practitioners = {
    favorites: profile
      ? profile?.favoritePractitioners?.map(({ practitionerId: id }) => id)
      : getFavoritePractionerIds(profiles),
    referring: profile
      ? referringPractitioner
      : getReferringPractitionerIds(profiles),
  };

  if (practitioners?.referring?.includes(practitionerId)) {
    return (
      <FontAwesomeIcon
        name="heart:solid"
        className="h-5 w-5 flex-shrink-0"
        color="#f68092"
        aria-label={t('my_attending_physician')}
      />
    );
  }
  if (practitioners?.favorites?.includes(practitionerId)) {
    return (
      <FontAwesomeIcon
        name="star:solid"
        className="h-5 w-5 flex-shrink-0"
        color="#F6E05E"
        aria-label={t('in_favorites')}
      />
    );
  }

  return null;
};

export default PractitionerFlag;
